<template>
	<div class="container dashboard flex flex-column">
		<section>
			<home-greeting :class="[!$mq.isDesktop() ? 'mt-8 mb-4' : 'mt-8']"/>
		</section>
		<section class="flex flex-wrap" v-if="!loading">
			<home-order :lastOrder="lastOrder" class="col-lg-6 px-0" :class="{'pl-0': $mq.isDesktop()}"/>
			<home-subscription class="col-lg-6 pr-0" :class="{'pl-0': !$mq.isDesktop()}"/>
		</section>

		<!--start: sezione gift card (commentare quando non serve)-->
		<!--<section class="dashboard mb-5">
			<div class="section-content with-shadow flex flex-column flex-vcenter  gift-dashboard ">
				<h2 class="center">Regala una gift card</h2>
				<p class="center">Le gift card Quomi sono il regalo perfetto per stupire tutti in cucina</p>
				<img data-background-image="example.webp" src="https://api.quomi.it/oldimg/gift_card_quomi.png" alt="gift" loading="lazy" :style="$mq.isDesktop() ? 'width: 20%' : null">
				<router-link :to="{name: 'gift-card'}"> 
					<CTA
						class="mt-5"
						:content="`Regala le gift card`"
						isArrow
					/>
				</router-link> 
			</div>
		</section>-->
		<!-- end: sezione giftcard -->

		<!--<home-ecommerce v-else />-->
		<last-order-widget :order="lastPaidOrder"/>

		<home-widget/>

		<!-- <section>
			<div class="section-content shadow-box tag-partner">
				<h2 class="pb-3">Scopri tutte le novità</h2>
				<p>Scopri tutta la convenienza dei nuovi prezzi a porzione e la nuova modalità in abbonamento!</p>
				<div class="news-cards col-12 flex justify-content-between">
					<div class="col-sm-4 col-md-3 col-lg-4 flex flex-column flex-vcenter" v-for="(image, i) in images" :key="i">
						<v-img
							max-height="80%"
							max-width="80%"
							:src="image.src"
						/>
						<h6 class="center pt-3">{{image.text}}</h6>
						<span class="center">{{image.paragraph}}</span>
					</div>
				</div>
				<router-link
					:to="{ name: 'how-it-works' }"
				>
					<CTA
						:content="`Scopri di più`"
						isArrow
					/>
				</router-link>
			</div>
		</section> -->

		<section>
			<widget-placeholder :widgetStyle="widgetStyle" :widgetClass="widgetClass" v-if="user" />
		</section>

		<!--<home-scratch class="tag-partner"/>	-->

		<!--<home-widget class="tag-partner" />-->

		<!--<home-progress-bar />-->	
		<div class="flex-stretch flex-listing tag-partner mb-5">
			<home-news class="mb-5"/>

			<home-recipe class="mb-5"/>

			<home-invite />
		</div>
	</div>
</template>

<script>

import HomeProgressBar from './HomeProgressBar'
import HomeEcommerce from './HomeEcommerce'
import HomeScratch from './HomeScratch'
import HomeInvite from './HomeInvite'
import HomeWidget from './HomeWidget'
import HomeRecipe from './HomeRecipe'
import HomeOrder from './HomeOrder'
import HomeNews from './HomeNews'
import HomeSubscription from './HomeSubscription'
import WidgetPlaceholder from '../WidgetPlaceholder'
import LastOrderWidget from '../Profile/LastOrderWidget'
import { dashboard } from '../../mixins/dashboard'
import HomeGreeting from './HomeGreeting'
import { UserApi } from '../../api/UserApi'
import { Order } from '../../core/Order'

export default {
	components: {
		WidgetPlaceholder,
		HomeProgressBar,
		HomeEcommerce,
		HomeScratch,
		HomeInvite,
		HomeWidget,
		HomeRecipe,
		HomeOrder,
		HomeNews,
		HomeSubscription,
		LastOrderWidget,
		HomeGreeting
	},

	data () {
		return {
			images: [
				{
					src: 'https://api.quomi.it/oldimg/Quomi-kit-ricette-a-casa.webp',
					text: "Nuovi prezzi a porzione",
					paragraph: "Nuovi prezzi legati solo al numero di porzioni, più acquisti e più risparmi.A partire da soli 4,45€ a porzione!"
				},
				{
					src: 'https://api.quomi.it/oldimg/Homepage2.png',
					text: "Una bottega sempre più ricca",
					paragraph: "Una selezione di prodotti di alta qualità, ora più facile da navigare grazie a filtri e ordinamento"
				},
				{
					src: 'https://api.quomi.it/oldimg/Homepage3_v2.png',
					text: "Nuova modalità in abbonamento!",
					paragraph: "Potrai riservare le tue modalità di consegna preferita e risparmiare le spese di spedizione, senza vincoli!"
				}
			],
			lastOrder: null,
			lastPaidOrder: null,
			loading: true
		}
  },

	computed: {
		user () {
			return this.$root.user
		},
		order () {
			return this.user ? this.user.order : null
		},

		widgetClass() {
			if(!this.$mq.isDesktop()) {
				return {
					'with-shadow': true
				}
			}
			return {
				'shadow-box': true,
			}
		},
		widgetStyle() {
			return {
				padding: "30px 50px",
				background: "white"
			}
		},
	},

	methods: {
		loadOrders () {
			this.loading = true
			var um = new UserApi()
			um.orders({
				page: 1,
				show: 3,
				sort: '-created_at',
				query: 'status != "canceled" and (status != "pending" or (status = "pending" and confirmed_at is not null and ok = 1))'
			}).then(response => {
				let orders = response.body.resources.filter(order => {
					return new Order(order)
				})
				if(orders.length > 0) {
					this.lastPaidOrder = orders.find(order => order.is_paid == true)
					this.lastOrder = orders[0]
				}
				this.loading = false
			})
		},

		load () {
			this.loadOrders()
		},
	},

	mounted() {
		this.load()
	},

	mixins: [
		dashboard
	]
}

</script>

<style scoped>

.container >>> .section-content {
	padding: 30px 50px;
}

.container >>> .shadow-box:hover::before {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.20);
}

.container >>> .slider-container.noArrows {
	margin: 0 0px;
}

.dashboard >>> section {
	padding: 0 10px 10px 10px;
	position: relative;
}

.gift-dashboard {
	background-image: url('https://api.quomi.it/oldimg/natale-quomi-header-aziende.webp');
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center 35%;
}

.to-bottom {
	order: 1;
}

.dashboard .flex-listing >>> section {
	flex-grow: 1;
	flex-basis: calc(100% / 3 - 20px);
	min-width: 320px;
}

.flex-listing {
	width: 100%;
	max-width: 1240px;
	margin-left: auto;
	margin-right: auto;
}

.dashboard >>> section {
	width: 100%;
	max-width: 1240px;
	margin-left: auto;
	margin-right: auto;
}

@media (max-width: 1024px) {
}

@media only screen and (max-width: 768px) { 
  .dashboard >>> .btn { 
    width: 100%;
	padding: .75rem .75rem;
  }
} 

@media only screen and (max-width: 640px) {
	.dashboard >>> .shadow-box:not(.recipe):not(.slider-arrow)::after,
	.dashboard >>> .shadow-box:not(.recipe):not(.slider-arrow)::before {
		display: none;
	}

	.dashboard >>> .shadow-box:hover {
		box-shadow: none;
	}

	.container >>> .section-content {
		padding: 30px 20px;
	}

	.news-cards {
		flex-direction: column;
	}
}
</style>
